export default "__VITE_ASSET__75f89dec__"